import { createContext, useContext, type ReactNode } from "react";
import type { Profile } from "../../shared/types/database";

const EditorProfileContext = createContext<Profile | null>(null);

export function EditorProfileProvider({ profile, children }: { profile: Profile; children: ReactNode }) {
  return <EditorProfileContext.Provider value={profile}>{children}</EditorProfileContext.Provider>;
}

export function useEditorProfile() {
  const profile = useContext(EditorProfileContext);
  if (!profile) throw new Error("Editor profile context is missing.");
  return profile;
}
